import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/partner_circle.svg")